import React from 'react'

import { useBuyContext } from '@Components/BuyButton/hooks'
import { PromptDialog } from '@Domains/Cart/Components/Prompt/Dialog'

export const BuyPrompts = () => {
  const { handlePromptSubmit, isLoading, prompts, reset, variables } = useBuyContext()

  if (!prompts || prompts.length === 0) {
    return null
  }

  return (
    <PromptDialog
      isLoading={isLoading}
      onClose={reset}
      onSubmit={handlePromptSubmit}
      prompts={prompts}
      promptsOrigin={variables}
    />
  )
}
